const FABRIC_DESKTOP_BREAKPOINT = 768;
let fabricDesktopInitialized = false;
let fabricCarouselInitialized = false;

function initDesktopFunctionality() {
  if (window.innerWidth >= FABRIC_DESKTOP_BREAKPOINT && !fabricDesktopInitialized) {
    fabricDesktopInitialized = true;
    let oldId = null;
    const tabLinks = document.querySelectorAll(".fabric-tabs-controls__link");
    const cards = document.querySelectorAll(".fabric-card");

    tabLinks.forEach((link) => {
      const newLink = link.cloneNode(true);
      link.parentNode.replaceChild(newLink, link);
    });

    const newTabLinks = document.querySelectorAll(
      ".fabric-tabs-controls__link"
    );

    newTabLinks.forEach((link) => {
      link.addEventListener("click", function (e) {
        e.preventDefault();

        if (this.classList.contains("active")) {
          return false;
        }

        const currentId = parseInt(this.dataset.id, 10);

        document
          .querySelector(".fabric-tabs-controls__link.active")
          ?.classList.remove("active");

        this.classList.add("active");

        if (currentId < oldId) {
          const currentlyActiveCard = document.querySelector(
            ".fabric-card.active"
          );

          cards.forEach((card, index) => {
            if (index === currentId - 1) {
              card.classList.remove("active", "sliding-out", "out");
              card.classList.add("sliding-in");

              setTimeout(() => {
                card.classList.remove("sliding-in");
                card.classList.add("active");
              }, 50);
            } else if (index >= currentId) {
              card.classList.remove(
                "active",
                "sliding-out",
                "sliding-in",
                "out"
              );
            } else {
              card.classList.remove("active", "sliding-out", "sliding-in");
              card.classList.add("out");
            }
          });
        } else {
          const currentlyActiveCard = document.querySelector(
            ".fabric-card.active"
          );

          cards.forEach((card, index) => {
            if (index === currentId - 1) {
              card.classList.remove("sliding-out", "out");
              card.classList.add("active");
            } else if (index < currentId - 1) {
              if (card === currentlyActiveCard) {
                card.classList.remove("active");
                card.classList.add("sliding-out");
                setTimeout(() => {
                  card.classList.remove("sliding-out");
                  card.classList.add("out");
                }, 100);
              } else {
                setTimeout(() => {
                  card.classList.remove("active");
                  card.classList.add("out");
                }, index * 100);
              }
            }
          });
        }

        oldId = currentId;
      });
    });

    if (newTabLinks.length > 0) {
      oldId = 1;
      if (cards[0]) {
        cards[0].classList.add("active");
      }
    }
  }
}

function initMobileCarousel() {
  if (window.innerWidth >= FABRIC_DESKTOP_BREAKPOINT || fabricCarouselInitialized) {
    return;
  }

  const emblaNode = document.querySelector(
    ".fabric-library .clickable-cards-carousel-mobile .embla__viewport"
  );
  const dotsNode = document.querySelector(".fabric-library .carousel-dots");
  const prevBtn = document.querySelector(".fabric-library .prev-btn");
  const nextBtn = document.querySelector(".fabric-library .next-btn");

  if (emblaNode && typeof EmblaCarousel !== "undefined") {
    fabricCarouselInitialized = true;
    const emblaApi = EmblaCarousel(emblaNode, {
      align: "center",
      containScroll: false,
    });

    const updateActiveSlide = () => {
      const slides = emblaNode.querySelectorAll(".embla__slide");
      const selectedIndex = emblaApi.selectedScrollSnap();

      slides.forEach((slide, index) => {
        slide.classList.remove("is-active");
        if (index === selectedIndex) {
          slide.classList.add("is-active");
        }
      });
    };

    const addDotBtnsAndClickHandlers = (emblaApi, dotsNode) => {
      let dotNodes = [];

      const addDotBtnsWithClickHandlers = () => {
        dotsNode.innerHTML = emblaApi
          .scrollSnapList()
          .map(
            () =>
              '<button class="carousel-dot" type="button" aria-label="Go to slide"></button>'
          )
          .join("");

        const scrollTo = (index) => {
          emblaApi.scrollTo(index);
        };

        dotNodes = Array.from(dotsNode.querySelectorAll(".carousel-dot"));
        dotNodes.forEach((dotNode, index) => {
          dotNode.addEventListener("click", () => scrollTo(index), false);
        });
      };

      const toggleDotBtnsActive = () => {
        const previous = emblaApi.previousScrollSnap();
        const selected = emblaApi.selectedScrollSnap();
        dotNodes[previous].classList.remove("carousel-dot--selected");
        dotNodes[selected].classList.add("carousel-dot--selected");
      };

      emblaApi
        .on("init", addDotBtnsWithClickHandlers)
        .on("reInit", addDotBtnsWithClickHandlers)
        .on("init", toggleDotBtnsActive)
        .on("reInit", toggleDotBtnsActive)
        .on("select", toggleDotBtnsActive)
        .on("select", updateActiveSlide)
        .on("init", updateActiveSlide);

      return () => {
        dotsNode.innerHTML = "";
      };
    };

    const addPrevNextBtnsClickHandlers = (emblaApi, prevBtn, nextBtn) => {
      const togglePrevNextBtnsState = () => {
        if (emblaApi.canScrollPrev()) {
          prevBtn.removeAttribute("disabled");
        } else {
          prevBtn.setAttribute("disabled", "disabled");
        }

        if (emblaApi.canScrollNext()) {
          nextBtn.removeAttribute("disabled");
        } else {
          nextBtn.setAttribute("disabled", "disabled");
        }
      };

      const scrollPrev = () => {
        if (emblaApi.canScrollPrev()) emblaApi.scrollPrev();
      };

      const scrollNext = () => {
        if (emblaApi.canScrollNext()) emblaApi.scrollNext();
      };

      prevBtn.addEventListener("click", scrollPrev, false);
      nextBtn.addEventListener("click", scrollNext, false);

      emblaApi
        .on("init", togglePrevNextBtnsState)
        .on("reInit", togglePrevNextBtnsState)
        .on("select", togglePrevNextBtnsState);

      return togglePrevNextBtnsState;
    };

    addDotBtnsAndClickHandlers(emblaApi, dotsNode);
    addPrevNextBtnsClickHandlers(emblaApi, prevBtn, nextBtn);
  }
}

function initFabricLibrary() {
  initDesktopFunctionality();
  initMobileCarousel();
}

initFabricLibrary();

window.addEventListener("resize", initFabricLibrary);

document.addEventListener("DOMContentLoaded", initFabricLibrary);
